import { toWSDateString } from "@wingspanhq/fe-component-library";
import { PayrollRun, PayrollRunStatus } from "@wingspanhq/wingspan-api-sdk";

/**
 * The short secondary status line under the status pill, e.g.
 * "Next payroll: Jun 5, 2026" or "Paid Jun 5, 2026". Derived from the run's
 * status plus its pay date / lifecycle events.
 *
 * The design's failed line is a payment failure reason; `PayrollRun` carries no
 * such field on v3, so failures fall back to a generic line.
 */
export const selectorPayrollRunStatusDetail = (
  payrollRun: PayrollRun
): string | undefined => {
  switch (payrollRun.status) {
    case PayrollRunStatus.DRAFT:
      return payrollRun.payDate
        ? `Next payroll: ${toWSDateString(payrollRun.payDate, "monthDayYear")}`
        : "Open";
    case PayrollRunStatus.FINALIZED:
    case PayrollRunStatus.PROCESSING:
      return "Processing";
    case PayrollRunStatus.PAID:
      return payrollRun.events?.paidAt
        ? `Paid ${toWSDateString(payrollRun.events.paidAt, "monthDayYear")}`
        : "Paid";
    case PayrollRunStatus.CANCELLED:
      return payrollRun.events?.cancelledAt
        ? `Cancelled ${toWSDateString(
            payrollRun.events.cancelledAt,
            "monthDayYear"
          )}`
        : "Payroll cancelled";
    case PayrollRunStatus.FAILED:
      return "Payroll failed";
    // `PendingApprovals`, `PartiallyPaid` and an absent status all read as pending.
    default:
      return "Payroll pending";
  }
};
